export const MOBILE_PHONE = 'MOBILE_PHONE';
export const BIRTH_DATE = 'BIRTH_DATE';
export const STRING = 'STRING';
export const EMAIL = 'EMAIL';
